try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}

$(document).ready(function () {

    // cart_dealer_select();

    if (jQuery) {
        // jQuery is loaded
        console.log("Yeah!");
    } else {
        // jQuery is not loaded
        alert("jQuery doesn't Work");
    }

    // Add function to add a class to the navbar when scrolled
    $(function () {
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop();

            if (scroll > 46) {
                $('.navbar').addClass('scrolled');
            } else {
                $('.navbar').removeClass('scrolled');
            }
        });
    });


    $(function () {
        $('#video').css({width: $(window).innerWidth() + 'px', height: $(window).innerHeight() + 'px'});

        $(window).resize(function () {
            $('#video').css({width: $(window).innerWidth() + 'px', height: $(window).innerHeight() + 'px'});
        });
    });


    $('section.home-collectionslider .slider .items').slick({
        // centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3,
        infinite: true,
        variableWidth: true,
        prevArrow: '<div class="prevbutton">',
        nextArrow: '<div class="nxtbutton">',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    // arrows: false,
                    // centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    // arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });


    $('section.related .relatedproductswrap').slick({
        // centerMode: true,
        // centerPadding: '40px',
        slidesToShow: 4,
        infinite: true,
        // variableWidth: true,
        prevArrow: '<div class="prevbutton">',
        nextArrow: '<div class="nxtbutton">',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    // arrows: false,
                    // centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    // arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });


    $("section.measurementtool .content-wrap .submit-wrap.to-step-2").click(function () {

        $("section.measurementtool .step.active").removeClass('active');
        $("section.measurementtool .step.step2").addClass('active');
        $("section.measurementtool img.imgstep2").css('display', 'block');
        $("section.measurementtool img.imgstep1").css('display', 'none');


    });

    cart_dealer_select();

    $(document.body).on('updated_wc_div', function () {
        cart_dealer_select();

    });


    function cart_dealer_select() {


        $(".woocommerce-cart form.woocommerce-cart-form .product-dealerpicker .simulatedselect .topline").click(function () {
            $(this).closest('.simulatedselect').toggleClass('active');
            $(".woocommerce-cart form.woocommerce-cart-form .product-dealerpicker .simulatedselect .topline").not(this).closest('.simulatedselect').removeClass("active");
        });


        $(".product-name select").each(function () {
            $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('.simulatedselect').addClass("show");
            var i = 0;
            $(this).find("option").each(function () {
                data = $(this).data("dealer_data");
                // console.log(data);

                if (typeof data !== 'undefined' && data !== false) {
                    if ($('div.simulatedselectoption[data-dealer_id="' + data.dealer_id + '"][data-variation_ean="' + data.variation_ean + '"]').length == 0) {
                        // console.log(data);
                        var addedblock = '';
                        addedblock += '<div class="simulatedselectoption" data-dealer_id="' + data.dealer_id + '" data-variation_ean="' + data.variation_ean + '" data-dealer_location="' + data.place + '" data-dealer_storename="' + data.dealer_storename + '" data-dealer_distance="' + data.distance_km + '"> ';
                        addedblock += '<img src="/app/uploads/2022/03/map_pointer_storesmall.png" alt=""><span class="store">' + data.dealer_storename + '</span>  - ' + data.street + ' - ' + data.postal_code + ' ' + data.place + ' ' + data.country;
                        addedblock += '<div class="distance">' + data.distance_km + ' km</div>';
                        addedblock += '</div>';

                        $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('.simulatedoptions').append(addedblock);

                        if ($(this).attr('selected') == 'selected') {
                            $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('.topline span.plaats').html(data.place);
                            $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('.topline span.store').html(data.dealer_storename);
                            $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('.topline div.distance').html(data.distance_km + ' km');

                        }
                        i++
                    }
                }

            });
        });

        $(".simulatedoptions .simulatedselectoption").click(function () {
            var dealerId = $(this).attr("data-dealer_id");
            var dealerPlace = $(this).attr("data-dealer_location");
            var dealerStorename = $(this).attr("data-dealer_storename");
            var dealerDistance = $(this).attr("data-dealer_distance");
            $(this).closest(".simulatedoptions").siblings(".topline").find('span.plaats').html(dealerPlace);
            $(this).closest(".simulatedoptions").siblings(".topline").find('span.store').html(dealerStorename);
            $(this).closest(".simulatedoptions").siblings(".topline").find('div.distance').html(dealerDistance + ' km');

            // $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('select option[value='+ id +']').attr('selected','selected');
            $(this).closest('.woocommerce-cart-form__cart-item.cart_item').find('select').val(dealerId).change();
            $('.simulatedselect').removeClass('active');

        });

    }


    $("section.measurementtool .content-wrap .submit-wrap.to-step-1").click(function () {

        $("section.measurementtool .step.active").removeClass('active');
        $("section.measurementtool .step.step1").addClass('active');
        $("section.measurementtool img.imgstep2").css('display', 'none');
        $("section.measurementtool img.imgstep1").css('display', 'block');
    });


    $("section.faqspagesection .vraag ul li").hover(function () {
        $(this).siblings("li").removeClass("active");
        var questionclass = $(this).attr("class");
        var updatedString = questionclass.replace("active", "");
        console.log("antwoord-" + updatedString);
        $(this).closest(".vraag").siblings(".antwoordwrap").find(".ant").removeClass("active");
        $(this).closest(".vraag").siblings(".antwoordwrap").find(".antwoord-" + updatedString).addClass("active");
        $(this).addClass("active");
    });


    $("section.faqspagesection .vraag ul li").click(function () {
        $(this).siblings("li").removeClass("active");
        var questionclass = $(this).attr("class");
        var updatedString = questionclass.replace("active", "");
        console.log("antwoord-" + updatedString);
        $(this).closest(".vraag").siblings(".antwoordwrap").find(".ant").removeClass("active");
        $(this).closest(".vraag").siblings(".antwoordwrap").find(".antwoord-" + updatedString).addClass("active");
        $(this).addClass("active");
    });


    $("section.faq .faqs .faq").click(function () {
        $(this).find('.answer').slideToggle();
        $(this).toggleClass('active');
    });


    $('.productsingle-wrap .pickingbtnswrap .togglebtn .dropdown .container input[type=radio]').change(function () {
        $('.productsingle-wrap .pickingbtnswrap .togglebtn .dropdown').removeClass('active');
    });

    $('.single-product select#pa_pasvorm_wijdtematen, .single-product select#pa_pasvorm_lengtematen').on('change', function () {
        var selectedwijdtemaat = $("#pa_pasvorm_wijdtematen option:selected").val();
        selectedwijdtemaat = selectedwijdtemaat.replace("maat_", "").toUpperCase();
        selectedwijdtemaat = selectedwijdtemaat.replace("_PLUS", "+");
        selectedwijdtemaat = selectedwijdtemaat.split("-")[0]; // Removes language code, e.g.: -en
        var selectedlengtemaat = $("#pa_pasvorm_lengtematen option:selected").val();
        selectedlengtemaat = selectedlengtemaat.replace("maat_", "");
        selectedlengtemaat = selectedlengtemaat.replace("_", ".");
        selectedlengtemaat = selectedlengtemaat.split("-")[0]; // Removes language code, e.g.: -en

        // retailerStock = JSON.stringify(retailerStock);
        if (retailerStock[selectedwijdtemaat] != undefined && retailerStock[selectedwijdtemaat].length > 0) {
            if (Object.values(retailerStock[selectedwijdtemaat]).includes(selectedlengtemaat)) {
                $("span.button.findbutton").addClass("active");
            } else {
                $("span.button.findbutton").removeClass("active");
            }
        } else {
            $("span.button.findbutton").removeClass("active");
        }
    });

    $(document.body).on('found_variation', function (event, variation) {
        if (variation.is_in_stock === false) {
            var storeButton = $('span.button.findbutton.extra.active').length;
            if (storeButton === 0) {
                var shopUrl = $('div.product-not-available input[name=shop_url]').val();
                var selectedWijtemaat = $('div.selectwrap select#pa_pasvorm_wijdtematen option:selected').val();
                selectedWijtemaat = selectedWijtemaat.split("-")[0]; // Removes language code, e.g.: -en
                var selectedLengtemaat = $('div.selectwrap select#pa_pasvorm_lengtematen option:selected').val();
                selectedLengtemaat = selectedLengtemaat.split("-")[0]; // Removes language code, e.g.: -en
                shopUrl = shopUrl + '?_breedtematen=' + selectedWijtemaat + '&_lengtematen=' + selectedLengtemaat;
                $('div.product-not-available a[name=shop_redirect]').attr("href", shopUrl);
                $('div.product-not-available').show();
            } else {
                $('div.product-not-available').hide();
            }
        } else {
            $('div.product-not-available').hide();
        }
    });

    $(".single-product .productsingle-wrap span.button").click(function () {
        var selectedlengtemaat = $("#pa_pasvorm_lengtematen option:selected").val();
        selectedlengtemaat = selectedlengtemaat.split("-")[0]; // Removes language code, e.g.: -en
        var selectedwijdtemaat = $("#pa_pasvorm_wijdtematen option:selected").val();
        selectedwijdtemaat = selectedwijdtemaat.split("-")[0]; // Removes language code, e.g.: -en
        if (selectedlengtemaat != "" && selectedlengtemaat != null && selectedwijdtemaat != "" && selectedwijdtemaat != null) {
            var lentemaatVal = selectedlengtemaat;
            var breedtemaatVal = selectedwijdtemaat;

            var storeUrl = $('input#hiddenstoreurl').val();
            var hiddenProductSKU = $('input#hiddenProductSKU').val();
            var hiddenProductName = $('input#hiddenProductName').val();
            var hiddenProductID = $('input#hiddenProductID').val();

            window.location.href = storeUrl + '?lengtemaat=' + lentemaatVal + '&breedtemaat=' + breedtemaatVal + "&sku=" + hiddenProductSKU + "&productname=" + hiddenProductName + "&hiddenProductID=" + hiddenProductID;
        }
        // console.log('l = ' + lentemaatVal + 'b = ' + breedtemaatVal + "str url =" + storeUrl);
    });

    $(".page-template-template_product_winkelzoeker .productsingle-wrap .pickingbtnswrap span.button").click(function () {
        var selectedlengtemaat = $("#pa_pasvorm_lengtematen option:selected").val();
        selectedlengtemaat = selectedlengtemaat.split("-")[0]; // Removes language code, e.g.: -en
        var selectedwijdtemaat = $("#pa_pasvorm_wijdtematen option:selected").val();
        selectedwijdtemaat = selectedwijdtemaat.split("-")[0]; // Removes language code, e.g.: -en
        if (selectedlengtemaat != "" && selectedlengtemaat != null && selectedwijdtemaat != "" && selectedwijdtemaat != null) {

            var storeUrl = $('input#hiddenstoreurl').val();
            var hiddenProductSKU = $('input#hiddenProductSKU').val();
            var hiddenProductName = $('input#hiddenProductName').val();
            var hiddenProductID = $('input#hiddenProductID').val();

            window.location.href = storeUrl + '?lengtemaat=' + selectedlengtemaat + '&breedtemaat=' + selectedwijdtemaat + "&sku=" + hiddenProductSKU + "&productname=" + hiddenProductName + "&hiddenProductID=" + hiddenProductID;
        }
        // console.log('l = ' + lentemaatVal + 'b = ' + breedtemaatVal + "str url =" + storeUrl);
    });


    $("section.closest-stores .filters .filter").click(function () {
        $(this).toggleClass('active');
    });

    $(".productsingle-wrap .pickingbtnswrap .togglebtn span.close").click(function () {
        $(this).siblings('.dropdown').toggleClass('active');
    });
    // $(".productsingle-wrap .pickingbtnswrap .togglebtn").click(function(){
    //   $(this).find('.dropdown').addClass('active');
    // });

//   $('.productsingle-wrap .pickingbtnswrap .togglebtn .dropdown .container input').click(function() {
//     if($('.productsingle-wrap .pickingbtnswrap .togglebtn.lengtemaat .dropdown .container input').is(':checked') && $('.productsingle-wrap .pickingbtnswrap .togglebtn.breedtemaat .dropdown .container input').is(':checked')) {
//       $(".productsingle-wrap .pickingbtnswrap span.button.inactive").removeClass('inactive');
//     } else{
//       $(".productsingle-wrap .pickingbtnswrap span.button.inactive").addClass('inactive');
//     }
//  });

    $("section.closest-stores .filters .filter.close").click(function () {
        $("section.closest-stores .filters .togglebox").slideToggle();
    });
    $("section.product-usps .button-wrap ul li").click(function () {
        $("section.product-usps .button-wrap ul li").removeClass('active');
        $(this).addClass('active');
        var targetID = $(this).attr("target-id");
        console.log(targetID);
        $("section.product-usps .content-tab").removeClass('active');
        $("section.product-usps .content-tab." + targetID).addClass('active');

    });

    $("section.shopfilters .filterswrap .togglebtn span.toggle").click(function () {
        if ($(this).closest(".togglebtn").hasClass("active")) {
            $(this).closest(".togglebtn").removeClass('active');
        } else {
            $("section.shopfilters .filterswrap .togglebtn").removeClass('active');
            $(this).closest(".togglebtn").addClass('active');
        }
    });
    // Close above when clicking outside
    $(document).on("click", function(e) {
        if (!$(e.target).closest("section.shopfilters .filterswrap .togglebtn").length) {
            $("section.shopfilters .filterswrap .togglebtn").removeClass("active");
        }
    });

    $("section.productspecifications .attributetoggleboxes .toggleblock h3").click(function () {
        if ($(this).closest('.toggleblock').hasClass("active")) {
            $(this).closest('.toggleblock').removeClass('active');
        } else {
            $("section.productspecifications .attributetoggleboxes .toggleblock").removeClass('active');
            $(this).closest('.toggleblock').addClass('active');
        }
    });

    $("section.shopfilters .filterswrap .togglebtn.meerfilters").click(function () {
        $('section.shopfilters .filterswrap .meerfiltersbox').slideToggle('fast');
    });

    $(".productsingle-wrap .summary span#colortypetogglebtn").click(function () {
        $(".colorvariation_popup").addClass('active');
    });
    $(".colorvariation_popup .content-wrap .close").click(function () {
        $(".colorvariation_popup").removeClass('active');
    });

    function init() {
        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 11,

            // The latitude and longitude to center the map (always required)
            center: new google.maps.LatLng(40.6700, -73.9400), // New York

            // How you would like to style the map.
            // This is where you would paste any style found on Snazzy Maps.
            styles: [
                {
                    "featureType": "all",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "weight": "2.00"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9c9c9c"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#7b7b7b"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#46bcec"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#c8d7d4"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#070707"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                }
            ]
        };

        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>
        var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, mapOptions);

        // Let's also add a marker while we're at it
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(40.6700, -73.9400),
            map: map,
            title: 'Snazzy!'
        });
    }

    $("nav.navbar #navMenuExample .navbar-start .menu-item.has-dropdown span.toggledropdown").click(function () {
        $(this).siblings('.navbar-dropdown').slideToggle();
        $(this).find('i').toggleClass('rotated');
    });

    $("span#btn-maattabel").click(function () {
        $('html, body').animate({
            scrollTop: $("section.measurementtool").offset().top - 100
        }, 1000);
    });

    // Smooth scrolling for anchor point "#product-info"
    document.querySelectorAll('a[href^="#product-info"]').forEach(anchor => {

        anchor.addEventListener('click', function (e) {

            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    });

    // End function
});


//Below is standard Bulma code to load the hamburger menu
document.addEventListener('DOMContentLoaded', function () {

    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any nav burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach(function ($el) {
            $el.addEventListener('click', function () {

                // Get the target from the "data-target" attribute
                var target = $el.dataset.target;
                var $target = document.getElementById(target);

                // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                $el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

            });
        });
    }

});
